var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_1",
    "data-name": "Component 74 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.208,
    height: 115.576,
    viewBox: "0 0 115.208 115.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 115.208,
    height: 115.576,
    transform: "translate(0 0)",
    fill: "#0e71f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165743",
    "data-name": "Group 165743",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117551",
    "data-name": "Path 117551",
    d: "M597.517,484.431h0a7.044,7.044,0,0,1-7.044-7.044V441.7a7.044,7.044,0,1,1,14.088,0v35.686a7.044,7.044,0,0,1-7.044,7.044",
    transform: "translate(-560.328 -412.468)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117552",
    "data-name": "Path 117552",
    d: "M1437.349,484.431h0a7.044,7.044,0,0,1-7.044-7.044V441.7a7.044,7.044,0,1,1,14.088,0v35.686a7.044,7.044,0,0,1-7.044,7.044",
    transform: "translate(-1357.285 -412.468)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117553",
    "data-name": "Path 117553",
    d: "M1018.662,71.965h0a7.044,7.044,0,0,1-7.044-7.044V7.046a7.044,7.044,0,0,1,14.088,0V64.922a7.044,7.044,0,0,1-7.044,7.044",
    transform: "translate(-959.973 -0.002)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117554",
    "data-name": "Path 117554",
    d: "M359.036,1567.849h0a7.044,7.044,0,0,1,7.044-7.044h64.461a7.044,7.044,0,1,1,0,14.088H366.08a7.044,7.044,0,0,1-7.044-7.044",
    transform: "translate(-340.706 -1481.123)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117555",
    "data-name": "Path 117555",
    d: "M0,1994.989H0a7.044,7.044,0,0,1,7.044-7.044h101.12a7.044,7.044,0,1,1,0,14.088H7.044A7.044,7.044,0,0,1,0,1994.989",
    transform: "translate(0 -1886.457)",
    fill: "#0e71f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLogo);
export default __webpack_public_path__ + "static/media/vector-logo.55fa0f9c1ae7b075b9d9cf34fc49129c.svg";
export { ForwardRef as ReactComponent };